import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lms-wizard-step',
  templateUrl: './wizard-step.component.html',
  styleUrls: ['./wizard-step.component.scss']
})
export class WizardStepComponent implements OnInit {
  @Input() title: string;
  @Input() hidden = false;
  @Input() isValid = true;
  @Input() isActive = false;
  @Input() isDone = false;
  @Input() isDisabled = true;
  @Input() disableWhenExit = true;

  @Input() showNext = true;
  @Input() showPrev = true;
  @Input() showDone = true;

  @Input() previousButton = 'wizard.previousButton';
  @Input() nextButton = 'wizard.nextButton';
  @Input() doneButton = 'wizard.doneButton';

  @Output() nextStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() previousStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() stepDone: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}
}
